/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { clickAreaClickHandler } from '../click-area-helper';
var clickWrapper = css({
  flexGrow: 1,
  height: '100%'
});
export var ClickAreaBlock = function ClickAreaBlock(_ref) {
  var editorView = _ref.editorView,
    editorDisabled = _ref.editorDisabled,
    children = _ref.children;
  var handleMouseDown = React.useCallback(function (event) {
    if (!editorView) {
      return;
    }
    if (!editorDisabled) {
      clickAreaClickHandler(editorView, event);
    }
  }, [editorView, editorDisabled]);
  return (
    // eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    jsx("div", {
      "data-editor-click-wrapper": true,
      "data-testid": "click-wrapper",
      css: clickWrapper,
      onMouseDown: handleMouseDown
    }, children)
  );
};
export default ClickAreaBlock;